import { DeleteOutline, KeyboardArrowDown, KeyboardArrowRight } from '@mui/icons-material';
import {
	Box,
	Button,
	Card,
	CardContent,
	CardHeader,
	CircularProgress,
	Collapse,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	FormControl,
	Grid,
	IconButton,
	InputLabel,
	MenuItem,
	Select,
	Tab,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	Tabs,
	TextField,
	ToggleButton,
	ToggleButtonGroup,
	Tooltip,
	Typography,
} from '@mui/material';
import { generateClient, post } from 'aws-amplify/api';
import { fetchAuthSession } from 'aws-amplify/auth';
import moment from 'moment';
import { enqueueSnackbar } from 'notistack';
import { useContext, useEffect, useState } from 'react';
import { updateCampaign } from 'src/graphql/mutations';
import {
	actionOneButtonStyle,
	actionTwoButtonStyle,
	tabStyle,
} from 'src/theme';
import { UserContext } from '../../contexts/UserContext';

/**
 * The ExportDialog component is used Allow users to choose how the export data
 * Expects No params our query string values on the route
 * * @category Components
 *  @component
 *
 */
const CampaignScheduleDialog = function (props) {
	const client = generateClient();
	const userContext = useContext(UserContext);
	const actions = [
		{ value: 'start', label: 'Start Campaign' },
		{ value: 'pause', label: 'Pause Campaign' },
		{ value: 'restart', label: 'Resume Campaign' },
		{ value: 'reset', label: 'Reset Campaign' },
		{ value: 'stop', label: 'End/Finalize Campaign' },
	];
	const [tab, setTab] = useState(0);
	const [campaign, setCampaign] = useState();
	const [newActionEvent, setNewActionEvent] = useState({
		time: '08:00',
		days: [],
		action: '',
		timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
	});
	const [newRatioEvent, setNewRatioEvent] = useState({
		time: '08:00',
		days: [],
		segments: [],
		timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
	});
	const [newReport, setNewReport] = useState({
		time: '10:00',
		days: [],
		type: '',
		timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    channel: '',
		emailAddress: '',
	});
	const [actionEvents, setActionEvents] = useState([]);
	const [ratioEvents, setRatioEvents] = useState([]);
	const [reportEvents, setReportEvents] = useState([]);
	const [toDelete, setToDelete] = useState({});
	const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

	const [availableReportChannels, setAvailableReportChannels] = useState([]);

	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (props.campaign) {

			// Set the available channels based on the campaign profile.
      const channels = props.campaign.profile?.channels ?? [];
      const formattedChannels = channels.map(channel => channel.type === 'Voice' ? 'Dial' : channel.type);
      setAvailableReportChannels(formattedChannels);
      setNewReport((prev) => ({
        ...prev,
        channel: formattedChannels[0] ?? '',
      }));

			setCampaign(props.campaign);
			if (props.campaign.campaignSchedule) {
				setActionEvents(JSON.parse(props.campaign.campaignSchedule));
			} else {
				setActionEvents([]);
			}
			if (props.campaign.segmentSchedule) {
				setRatioEvents(JSON.parse(props.campaign.segmentSchedule));
			} else {
				setRatioEvents([]);
			}
			if (props.campaign.segments && props.campaign.segments.length > 0) {
				const campaignSegments = JSON.parse(
					JSON.stringify(props.campaign.segments),
				);
				setNewRatioEvent({
					...newRatioEvent,
					segments: JSON.parse(campaignSegments),
				});
			}

			if (props.campaign.reportSchedule) {
				setReportEvents(JSON.parse(props.campaign.reportSchedule));
			} else {
				setReportEvents([]);
			}
		}
	}, [props.campaign]);

	/** Close refund dialog */
	async function closeDialog() {
		if (props.onCancel) {
			props.onCancel();
		}
	}

	async function addEvent(type) {
		try {
			if (type === 'campaignStatus') {
				if (
					!newActionEvent.time ||
					newActionEvent.days.length === 0 ||
					newActionEvent.action === ''
				) {
					enqueueSnackbar('Please fill out all fields', { variant: 'error' });
					return;
				}
			}
			if (type === 'segmentRatio') {
				if (
					!newRatioEvent.time ||
					newRatioEvent.days.length === 0 ||
					newRatioEvent.segments.length === 0
				) {
					enqueueSnackbar('Please fill out all fields', { variant: 'error' });
					return;
				}
			}
			if (type === 'report') {
				if (
					!newReport.time ||
					newReport.days.length === 0 ||
					newReport.type === '' ||
					newReport.emailAddress === ''
				) {
					enqueueSnackbar('Please fill out all fields', { variant: 'error' });
					return;
				}
			}

			setLoading(true);
			const eventId = Math.floor(100000 + Math.random() * 900000);

			let body = {
				tenant: userContext.tenantId,
				campaignId: campaign.id,
				eventType: type,
			};

			if (type === 'campaignStatus') {
				newActionEvent.id = eventId;
				body.event = newActionEvent;
			} else if (type === 'segmentRatio') {
				newRatioEvent.id = eventId;
				body.event = newRatioEvent;
			} else if (type === 'report') {
				newReport.id = eventId;
				body.event = newReport;
			}

			const create = await post({
				apiName: 'cdyxoutreach',
				path: '/approver/create-schedule',
				options: {
					headers: {
						Authorization: `Bearer ${(await fetchAuthSession()).tokens.idToken}`,
						'x-api-key': userContext.apiKey,
					},
					body: {
						...body,
					},
				},
			}).response;

			const result = await create.body.json();

			newActionEvent.scheduleArn = result.ScheduleArn;

			if (type === 'campaignStatus') {
				await client.graphql({
					query: updateCampaign,
					variables: {
						input: {
							id: campaign.id,
							campaignSchedule: JSON.stringify([
								...actionEvents,
								newActionEvent,
							]),
							updatedBy: userContext.email
						},
					},
				});

				setActionEvents([...actionEvents, newActionEvent]);
				setNewActionEvent({
					time: moment(newActionEvent.time, 'HH:mm')
						.add(5, 'minutes')
						.format('HH:mm'),
					days: newActionEvent.days,
					action: '',
					timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				});
			} else if (type === 'segmentRatio') {
				await client.graphql({
					query: updateCampaign,
					variables: {
						input: {
							id: campaign.id,
							segmentSchedule: JSON.stringify([...ratioEvents, newRatioEvent]),
							updatedBy: userContext.email,
						},
					},
				});

				setRatioEvents([...ratioEvents, newRatioEvent]);
				setNewRatioEvent({
					time: moment(newRatioEvent.time, 'HH:mm')
						.add(5, 'minutes')
						.format('HH:mm'),
					days: newRatioEvent.days,
					segments: newRatioEvent.segments,
					timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
				});
			} else if (type === 'report') {
				await client.graphql({
					query: updateCampaign,
					variables: {
						input: {
							id: campaign.id,
							reportSchedule: JSON.stringify([...reportEvents, newReport]),
							updatedBy: userContext.email
						},
					},
				});

				setReportEvents([...reportEvents, newReport]);
				setNewReport({
					time: moment(newReport.time, 'HH:mm').format('HH:mm'),
					days: newReport.days,
					type: '',
					timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
					channel: 'Dial',
					emailAddress: newReport.emailAddress,
				});
			}

			enqueueSnackbar('Event added successfully', { variant: 'success' });
		} catch (error) {
			console.error('Error adding event', error);
		}
		setLoading(false);
	}

	async function deleteEvent() {
		try {
			setDeleteDialogOpen(false);
			setLoading(true);

			try {
				await post({
					apiName: 'cdyxoutreach',
					path: '/approver/create-schedule',
					options: {
						headers: {
							Authorization: `Bearer ${(await fetchAuthSession()).tokens.idToken}`,
							'x-api-key': userContext.apiKey,
						},
						body: {
							delete: true,
							tenant: userContext.tenantId,
							campaignId: campaign.id,
							event: toDelete,
						},
					},
				}).response;
			} catch (err) {
				console.error('Error deleting EventBridge event', err);
			}

			await client.graphql({
				query: updateCampaign,
				variables: {
					input: {
						id: campaign.id,
						campaignSchedule: JSON.stringify(
							actionEvents.filter((event) => event.id !== toDelete.id),
						),
						segmentSchedule: JSON.stringify(
							ratioEvents.filter((event) => event.id !== toDelete.id),
						),
						reportSchedule: JSON.stringify(
							reportEvents.filter((event) => event.id !== toDelete.id),
						),
						updatedBy: userContext.email
					},
				},
			});

			setActionEvents(actionEvents.filter((event) => event.id !== toDelete.id));
			setRatioEvents(ratioEvents.filter((event) => event.id !== toDelete.id));
			setReportEvents(reportEvents.filter((event) => event.id !== toDelete.id));

			enqueueSnackbar('Event deleted successfully', { variant: 'success' });
		} catch (err) {
			enqueueSnackbar('Error deleting event', { variant: 'error' });
			console.error('Error deleting event', err);
		}

		setLoading(false);
	}

	return (
		<div>
			<Dialog maxWidth="xl" open={props.open}>
				<DialogTitle id="dp-dialog-title">
					Scheduling {props.campaign?.name}
				</DialogTitle>
				<DialogContent>
					<Grid container>
						<Grid item xs={12}>
							<Tabs
								value={tab}
								indicatorColor="primary"
								textColor="primary"
								variant="fullWidth"
							>
								<Tab
									sx={tabStyle}
									onClick={() => setTab(0)}
									label="Campaign Actions"
									value={0}
								/>
								<Tab
									sx={tabStyle}
									onClick={() => setTab(1)}
									label="Segment Ratios"
									value={1}
								/>
								<Tab
									sx={tabStyle}
									onClick={() => setTab(2)}
									label="Reports"
									value={2}
								/>
							</Tabs>
							{tab === 0 && (
								<Box display="flex" flexDirection="column" gap={2}>
									<Card variant="outlined">
										<CardHeader
											title="New Action Event"
											titleTypographyProps={{
												variant: 'body2',
												color: 'textSecondary',
											}}
										/>
										<CardContent>
											{!loading && (
												<Box
													display="grid"
													gridTemplateColumns="1fr 1fr"
													gap={2}
													alignItems="center"
												>
													<ToggleButtonGroup
														value={newActionEvent.days}
														onChange={(e, days) =>
															setNewActionEvent({ ...newActionEvent, days })
														}
													>
														<ToggleButton value={0}>SU.</ToggleButton>
														<ToggleButton value={1}>MO.</ToggleButton>
														<ToggleButton value={2}>TU.</ToggleButton>
														<ToggleButton value={3}>WE.</ToggleButton>
														<ToggleButton value={4}>TH.</ToggleButton>
														<ToggleButton value={5}>FR.</ToggleButton>
														<ToggleButton value={6}>SA.</ToggleButton>
													</ToggleButtonGroup>

													<TextField
														variant="outlined"
														type="time"
														value={newActionEvent.time}
														onChange={(e) =>
															setNewActionEvent({
																...newActionEvent,
																time: e.target.value,
															})
														}
													/>

													<FormControl>
														<InputLabel id="action">Action</InputLabel>
														<Select
															labelId="action"
															label="Action"
															value={newActionEvent.action}
															onChange={(e) =>
																setNewActionEvent({
																	...newActionEvent,
																	action: e.target.value,
																})
															}
														>
															{actions.map((action) => (
																<MenuItem
																	key={action.value}
																	value={action.value}
																>
																	{action.label}
																</MenuItem>
															))}
														</Select>
													</FormControl>

													<Button
														sx={actionOneButtonStyle}
														onClick={() => addEvent('campaignStatus')}
														variant="contained"
														color="primary"
													>
														Add Event
													</Button>

													<Typography variant="body2" color="textSecondary">
														This event's timing is based off of the{' '}
														{Intl.DateTimeFormat().resolvedOptions().timeZone}{' '}
														timezone
													</Typography>
												</Box>
											)}
										</CardContent>
									</Card>
									<Card variant="outlined">
										<CardHeader
											title="Scheduled Action Events"
											titleTypographyProps={{
												variant: 'body2',
												color: 'textSecondary',
											}}
										/>
										<CardContent>
											<Table>
												<TableHead>
													<TableRow>
														<TableCell>Time</TableCell>
														<TableCell>Timezone</TableCell>
														<TableCell>Days</TableCell>
														<TableCell>Action</TableCell>
														<TableCell>Delete</TableCell>
													</TableRow>
												</TableHead>
												<TableBody>
													{actionEvents.map((event) => (
														<TableRow key={event.id}>
															<TableCell>
																{moment(event.time, 'HH:mm').format('hh:mm a')}
															</TableCell>
															<TableCell>{event.timeZone}</TableCell>
															<TableCell>
																{event.days.includes(0) && (
																	<ToggleButton
																		style={{ width: '1.5em', height: '1em' }}
																	>
																		SU.
																	</ToggleButton>
																)}
																{event.days.includes(1) && (
																	<ToggleButton
																		style={{ width: '1.5em', height: '1em' }}
																	>
																		MO.
																	</ToggleButton>
																)}
																{event.days.includes(2) && (
																	<ToggleButton
																		style={{ width: '1.5em', height: '1em' }}
																	>
																		TU.
																	</ToggleButton>
																)}
																{event.days.includes(3) && (
																	<ToggleButton
																		style={{ width: '1.5em', height: '1em' }}
																	>
																		WE.
																	</ToggleButton>
																)}
																{event.days.includes(4) && (
																	<ToggleButton
																		style={{ width: '1.5em', height: '1em' }}
																	>
																		TH.
																	</ToggleButton>
																)}
																{event.days.includes(5) && (
																	<ToggleButton
																		style={{ width: '1.5em', height: '1em' }}
																	>
																		FR.
																	</ToggleButton>
																)}
																{event.days.includes(6) && (
																	<ToggleButton
																		style={{ width: '1.5em', height: '1em' }}
																	>
																		SA.
																	</ToggleButton>
																)}
															</TableCell>
															<TableCell>
																{event.action === 'start' && 'Start'}
																{event.action === 'pause' && 'Pause'}
																{event.action === 'restart' && 'Resume'}
																{event.action === 'reset' && 'Reset'}
																{event.action === 'stop' && 'End'}
															</TableCell>
															<TableCell>
																<IconButton
																	onClick={() => {
																		setToDelete(event);
																		setDeleteDialogOpen(true);
																	}}
																>
																	<DeleteOutline color="primary" />
																</IconButton>
															</TableCell>
														</TableRow>
													))}
												</TableBody>
											</Table>
										</CardContent>
									</Card>
								</Box>
							)}
							{tab === 1 && (
								<Box display="flex" flexDirection="column" gap={2}>
									<Card variant="outlined">
										<CardHeader
											title="New Segment Ratio Change Event"
											titleTypographyProps={{
												variant: 'body2',
												color: 'textSecondary',
											}}
										/>
										<CardContent>
											{!loading && <>
												<Box
													display="grid"
													gridTemplateColumns="1fr 1fr"
													gap={2}
													alignItems="center"
												>
													<Box gridColumn="1 / span 2">
														<ToggleButtonGroup
															value={newRatioEvent.days}
															onChange={(e, days) =>
																setNewRatioEvent({ ...newRatioEvent, days })
															}
														>
															<ToggleButton value={0}>SU.</ToggleButton>
															<ToggleButton value={1}>MO.</ToggleButton>
															<ToggleButton value={2}>TU.</ToggleButton>
															<ToggleButton value={3}>WE.</ToggleButton>
															<ToggleButton value={4}>TH.</ToggleButton>
															<ToggleButton value={5}>FR.</ToggleButton>
															<ToggleButton value={6}>SA.</ToggleButton>
														</ToggleButtonGroup>
													</Box>

													<TextField
														variant="outlined"
														type="time"
														value={newRatioEvent.time}
														onChange={(e) =>
															setNewRatioEvent({
																...newRatioEvent,
																time: e.target.value,
															})
														}
													/>

													<TextField
														variant='outlined'
														type='text'
														value={newRatioEvent.name}
														onChange={e => setNewRatioEvent({ ...newRatioEvent, name: e.target.value })}
														placeholder="Enter a name (optional)"
													/>
												</Box>

												<Typography variant='body2' color='textSecondary' sx={{mt: 4, mb: 2}}>Segments</Typography>
												<Box display="grid" gridTemplateColumns="1fr 1fr" gap={2} alignItems="center">
													{newRatioEvent.segments &&
														newRatioEvent.segments.map((segment) => (
															<TextField
																label={segment.segmentName}
																variant="outlined"
																type="number"
																InputProps={{
																	inputProps: {
																		max: 100,
																		min: 0,
																	},
																}}
																value={segment.segmentRatio}
																onChange={(e) => {
																	const updatedSegments =
																		newRatioEvent.segments.map((s) => {
																			if (s.segmentId === segment.segmentId) {
																				return {
																					...s,
																					segmentRatio: e.target.value,
																				};
																			}
																			return s;
																		});
																	setNewRatioEvent({
																		...newRatioEvent,
																		segments: updatedSegments,
																	});
																}}
															/>
														))}

													<Button
														sx={actionOneButtonStyle}
														onClick={() => addEvent('segmentRatio')}
														variant="contained"
														color="primary"
													>
														Add Event
													</Button>

													<Typography variant="body2" color="textSecondary">
														This event's timing is based off of the{' '}
														{Intl.DateTimeFormat().resolvedOptions().timeZone}{' '}
														timezone
													</Typography>
												</Box>
											</>}
											{loading && (
												<Box
													display="flex"
													justifyContent="center"
													alignItems="center"
													height="100%"
												>
													<CircularProgress size={24} color="primary" />
												</Box>
											)}
										</CardContent>
									</Card>

									<Card variant="outlined">
										<CardHeader
											title="Scheduled Ratio Change Events"
											titleTypographyProps={{
												variant: 'body2',
												color: 'textSecondary',
											}}
										/>
										<CardContent>
											<Table>
												<TableHead>
													<TableRow>
														<TableCell></TableCell>
														<TableCell>Name</TableCell>
														<TableCell>Time</TableCell>
														<TableCell>Timezone</TableCell>
														<TableCell>Days</TableCell>
														<TableCell>Delete</TableCell>
													</TableRow>
												</TableHead>
												<TableBody>
													{ratioEvents.map((event) => (
														<>
															<TableRow key={event.id}>
																<TableCell>
																	<Tooltip title={event.open ? 'Hide Segments' : 'Show Segments'}>
																		<IconButton
																			aria-label="expand row"
																			size="small"
																			onClick={() => {
																				const updatedEvents = ratioEvents.map(e => {
																					if (e.id === event.id) {
																						return { ...e, open: !e.open };
																					}
																					return e;
																				});
																				setRatioEvents(updatedEvents);
																			}}
																		>
																			{event.open ? <KeyboardArrowDown /> : <KeyboardArrowRight />}
																		</IconButton>
																	</Tooltip>
																</TableCell>

																<TableCell>{event.name ? event.name : 'Unnamed Event'}</TableCell>
																<TableCell>
																	{moment(event.time, 'HH:mm').format('hh:mm a')}
																</TableCell>
																<TableCell>{event.timeZone}</TableCell>
																<TableCell>
																	{event.days.includes(0) && (
																		<ToggleButton
																			style={{ width: '1.5em', height: '1em' }}
																		>
																			SU.
																		</ToggleButton>
																	)}
																	{event.days.includes(1) && (
																		<ToggleButton
																			style={{ width: '1.5em', height: '1em' }}
																		>
																			MO.
																		</ToggleButton>
																	)}
																	{event.days.includes(2) && (
																		<ToggleButton
																			style={{ width: '1.5em', height: '1em' }}
																		>
																			TU.
																		</ToggleButton>
																	)}
																	{event.days.includes(3) && (
																		<ToggleButton
																			style={{ width: '1.5em', height: '1em' }}
																		>
																			WE.
																		</ToggleButton>
																	)}
																	{event.days.includes(4) && (
																		<ToggleButton
																			style={{ width: '1.5em', height: '1em' }}
																		>
																			TH.
																		</ToggleButton>
																	)}
																	{event.days.includes(5) && (
																		<ToggleButton
																			style={{ width: '1.5em', height: '1em' }}
																		>
																			FR.
																		</ToggleButton>
																	)}
																	{event.days.includes(6) && (
																		<ToggleButton
																			style={{ width: '1.5em', height: '1em' }}
																		>
																			SA.
																		</ToggleButton>
																	)}
																</TableCell>
																<TableCell>
																	<IconButton
																		onClick={() => {
																			setToDelete(event);
																			setDeleteDialogOpen(true);
																		}}
																	>
																		<DeleteOutline color="primary" />
																	</IconButton>
																</TableCell>
															</TableRow>

															{/* Collapsible Segments */}
															<TableRow>
																<TableCell style={{ padding: 0 }} colSpan={6}>
																	<Collapse in={event.open} timeout="auto" unmountOnExit>
																		<Grid container spacing={2} style={{
																			padding: 15,
																			backgroundColor: '#f0f0f0',
																			borderTop: '1px solid #e0e0e0',
																			borderBottom: '1px solid #e0e0e0'
																		}}>
																			{event.segments.map(segment => (
																				<Grid item xs={4} sm={3} key={segment.segmentId}>

																					<Card>
																						<CardContent>
																							<Typography align='center' style={{ fontWeight: 'bold', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }} variant='body2'>{segment.segmentName}</Typography>
																							<Typography align='center' variant='body2'>{segment.segmentRatio}</Typography>
																						</CardContent>
																					</Card>

																				</Grid>
																			))}
																		</Grid>
																	</Collapse>
																</TableCell>
															</TableRow>
														</>
													))}
												</TableBody>
											</Table>
										</CardContent>
									</Card>
								</Box>
							)}
							{tab === 2 && (
								<Box display="flex" flexDirection="column" gap={2}>
									<Card variant="outlined">
										<CardHeader
											title="New Report Event"
											titleTypographyProps={{
												variant: 'body2',
												color: 'textSecondary',
											}}
										/>
										<CardContent>
											{!loading && (
												<Box
													display="grid"
													gridTemplateColumns="1fr 1fr"
													gap={2}
													alignItems="center"
												>
													<ToggleButtonGroup
														value={newReport.days}
														onChange={(e, days) =>
															setNewReport({ ...newReport, days })
														}
													>
														<ToggleButton value={0}>SU.</ToggleButton>
														<ToggleButton value={1}>MO.</ToggleButton>
														<ToggleButton value={2}>TU.</ToggleButton>
														<ToggleButton value={3}>WE.</ToggleButton>
														<ToggleButton value={4}>TH.</ToggleButton>
														<ToggleButton value={5}>FR.</ToggleButton>
														<ToggleButton value={6}>SA.</ToggleButton>
													</ToggleButtonGroup>

													<TextField
														variant="outlined"
														type="time"
														shouldDisableTime={(value, view) =>
															view === 'hours' &&
															value.hour() > 5 &&
															value.hour() < 10
														}
														value={newReport.time}
														onChange={(e) =>
															setNewReport({
																...newReport,
																time: e.target.value,
															})
														}
													/>

													<FormControl>
														<InputLabel id="channel">Channel</InputLabel>
														<Select
															labelId="channel"
															label="Channel"
															value={newReport.channel}
															onChange={e => setNewReport({ ...newReport, channel: e.target.value })}
														>
															{availableReportChannels.map(channel => (
																<MenuItem key={channel} value={channel}>{channel}</MenuItem>
															))}
														</Select>
													</FormControl>

													<FormControl>
														<InputLabel id="report">Report</InputLabel>
														<Select
															labelId="report"
															label="Report"
															value={newReport.type}
															onChange={(e) => {
																setNewReport({
																	...newReport,
																	type: e.target.value,
																});
															}}
														>
															<MenuItem value='rollingReport'>Rolling Call Count</MenuItem>
															<MenuItem value='rollingSuppression'>Rolling Suppression Counts</MenuItem>
															<MenuItem value="rollingAgentDisposition">Rolling Dispositions</MenuItem>
															<MenuItem value='rollingCampaignPenetration'>Rolling Campaign Penetration</MenuItem>
															<MenuItem value='rollingMonthDisposition'>Rolling Month Dispositions</MenuItem>
														</Select>
													</FormControl>

													<TextField
														label="Email"
														variant="outlined"
														type="email"
														value={newReport.emailAddress}
														onChange={(e) =>
															setNewReport({
																...newReport,
																emailAddress: e.target.value,
															})
														}
													/>

													<Button
														sx={actionOneButtonStyle}
														onClick={() => addEvent('report')}
														variant="contained"
														color="primary"
													>
														Add Report
													</Button>

													<Typography variant="body2" color="textSecondary">
														This event's timing is based off of the{' '}
														{Intl.DateTimeFormat().resolvedOptions().timeZone}{' '}
														timezone
													</Typography>
												</Box>
											)}
											{loading && (
												<Box
													display="flex"
													justifyContent="center"
													alignItems="center"
													height="100%"
												>
													<CircularProgress size={24} color="primary" />
												</Box>
											)}
										</CardContent>
									</Card>

									<Card variant="outlined">
										<CardHeader
											title="Scheduled Reports"
											titleTypographyProps={{
												variant: 'body2',
												color: 'textSecondary',
											}}
										/>
										<CardContent>
											<Table>
												<TableHead>
													<TableRow>
														<TableCell>Time</TableCell>
														<TableCell>Timezone</TableCell>
														<TableCell>Days</TableCell>
														<TableCell>Channel</TableCell>
														<TableCell>Report</TableCell>
														<TableCell>Delete</TableCell>
													</TableRow>
												</TableHead>
												<TableBody>
													{
														reportEvents.map(event => <TableRow key={event.id}>
															<TableCell>{moment(event.time, 'HH:mm').format('hh:mm a')}</TableCell>
															<TableCell>{event.timeZone}</TableCell>
															<TableCell>
																{event.days.includes(0) && <ToggleButton style={{ width: '1.5em', height: '1em' }}>SU.</ToggleButton>}
																{event.days.includes(1) && <ToggleButton style={{ width: '1.5em', height: '1em' }}>MO.</ToggleButton>}
																{event.days.includes(2) && <ToggleButton style={{ width: '1.5em', height: '1em' }}>TU.</ToggleButton>}
																{event.days.includes(3) && <ToggleButton style={{ width: '1.5em', height: '1em' }}>WE.</ToggleButton>}
																{event.days.includes(4) && <ToggleButton style={{ width: '1.5em', height: '1em' }}>TH.</ToggleButton>}
																{event.days.includes(5) && <ToggleButton style={{ width: '1.5em', height: '1em' }}>FR.</ToggleButton>}
																{event.days.includes(6) && <ToggleButton style={{ width: '1.5em', height: '1em' }}>SA.</ToggleButton>}
															</TableCell>
															<TableCell>
                                {event.channel}
                              </TableCell>
															<TableCell>
                                {event.type === 'rollingReport' && `Rolling ${event.channel === 'Dial' ? 'Call' : event.channel} Count`}
																{event.type === 'rollingSuppression' && 'Rolling Suppression Counts'}
																{event.type === 'rollingAgentDisposition' && 'Rolling Dispositions'}
																{event.type === 'rollingCampaignPenetration' && 'Rolling Campaign Penetration'}
																{event.type === 'rollingMonthDisposition' && 'Rolling Month Dispositions'}
															</TableCell>
															<TableCell><IconButton onClick={() => {
																setToDelete(event);
																setDeleteDialogOpen(true);
															}} ><DeleteOutline color="primary" /></IconButton></TableCell>
														</TableRow>)
													}
												</TableBody >
											</Table >
										</CardContent >
									</Card >
								</Box >
							)}
						</Grid >
					</Grid >
				</DialogContent >
				<DialogActions>
					<Button
						onClick={closeDialog}
						sx={actionTwoButtonStyle}
						color="primary"
					>
						Close
					</Button>
				</DialogActions>
			</Dialog >
			<Dialog open={deleteDialogOpen}>
				<DialogTitle>Delete Event</DialogTitle>
				<DialogContent>
					<Typography>Are you sure you want to delete this event?</Typography>
				</DialogContent>
				<DialogActions>
					<Button
						variant="outlined"
						onClick={() => setDeleteDialogOpen(false)}
						color="primary"
					>
						Cancel
					</Button>
					<Button
						variant="contained"
						onClick={() => deleteEvent()}
						color="primary"
					>
						Delete
					</Button>
				</DialogActions>
			</Dialog>
		</div >
	);
};
export default CampaignScheduleDialog;
